import React, { useState, useEffect } from 'react';
import { Flex } from '@chakra-ui/react';
import DotSpinner from 'components/DotSpinner/DotSpinner';
import ButtonComponent from './ButtonComponent';

import { useCreateTemplateMutation } from 'modules/templates/templatesApi';

export default function SetTemplateName({
  setModalState,
  sm,
  closeModal,
  templateFile,
  currentFonts,
  refresh,
  file,
  onSuccess,
  setStep,
  templateHeight,
}) {
  const [showCancelBtn, setShowCancelBtn] = useState(false);

  const [createTemplate] = useCreateTemplateMutation();

  const getFontFilename = (postscriptname, fonts) => {
    const font = fonts.find(x => x.postscriptname === postscriptname);
    return font?.file?.file_name;
  };

  function flattenObject(obj) {
    return Object.keys(obj).reduce((arr, key) => {
      const innerArr = obj[key].map(item => ({
        ...item,
        family: key,
      }));
      return [...arr, ...innerArr];
    }, []);
  }

  const addFontFilenames = (template, currentFonts) => {
    // design_importer is not aware of font filenames so we must add them.  The stitcher
    // uses the __fontFilename key to resolve fonts so here we apply the property to any
    // vars that have a fontFamily key assigned.
    // TODO: font handling should be redone in this whole process later
    const publicFonts = flattenObject(currentFonts.public);
    const fonts = [...currentFonts.private, ...publicFonts];
    const updatedVars = template.ad_template_vars.map(x => {
      if (x.metadata.fontFamily) {
        const fontFn = getFontFilename(x.metadata.postscriptname, fonts);
        if (fontFn && !x.metadata.__fontFilename) {
          x.metadata.__fontFilename = fontFn;
        }
      }
      return x;
    });
    template.ad_template_vars = updatedVars;
    return template;
  };

  const createTemplateHandler = async () => {
    try {
      let payload = { ...templateFile, name: file.name };

      if (!templateFile.is_portrait) {
        payload = {
          ...payload,
          ad_template_vars: invertItemsPositions(
            payload.ad_template_vars,
            templateHeight
          ),
        };
      }

      await createTemplate(addFontFilenames(payload, currentFonts)).unwrap();
      onSuccess();
      closeModal();
      refresh();
    } catch (error) {
      setModalState({
        title: 'Error',
        description: 'Something went wrong.\nPlease try againg',
      });
      setShowCancelBtn(true);
    }
  };

  const invertItemsPositions = (vars, templateHeight) =>
    vars.map(item => ({
      ...item,
      pos_x: templateHeight - item.pos_y,
      pos_y: item.pos_x,
    }));

  useEffect(() => {
    setShowCancelBtn(false);
    setModalState({ title: 'Loading', description: '' });
    if (templateFile) {
      createTemplateHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateFile]);

  return (
    <Flex justify="center" minW={sm ? '500px' : '250px'} mt="2.5rem">
      {!showCancelBtn && <DotSpinner />}
      {showCancelBtn && (
        <ButtonComponent
          p={sm ? '14px 100px' : '14px 21px'}
          fontSize="20px"
          onClick={() => setStep(0)}
        >
          OK
        </ButtonComponent>
      )}
    </Flex>
  );
}
